module.exports = __webpack_public_path__ + "img/dloons_promo.fc7c36d7.png";